import CertificateModal from './CertificateModal';

export interface CertificateData {
  type: string;
  amount: string;
}

export default class GiftCertificates {
  private modal: CertificateModal;

  constructor() {
    this.modal = new CertificateModal();
    this.bindCardButtons();
    this.bindCtaButton();
  }

  private handleCardClick = (e: Event): void => {
    e.stopPropagation();
    const btn = e.currentTarget as HTMLButtonElement;
    const card = btn.closest('.gift-cert-card') as HTMLElement;
    const type = card?.dataset.certType || '';
    const amount = btn.dataset.certAmount || '';
    this.modal.open({ type, amount });
  };

  private handleCtaClick = (e: Event): void => {
    e.stopPropagation();
    this.modal.open({ type: '', amount: '' });
  };

  private bindCardButtons(): void {
    document.querySelectorAll<HTMLButtonElement>('.gift-cert-card__btn').forEach((btn) => {
      btn.addEventListener('click', this.handleCardClick);
    });
  }

  private bindCtaButton(): void {
    const ctaBtn = document.querySelector<HTMLButtonElement>('.btn_cert-request');
    ctaBtn?.addEventListener('click', this.handleCtaClick);
  }
}
